import React from 'react';
import PropTypes from 'prop-types';

import {Stack, IconButton, Box} from 'views/components';
import {Edit} from 'views/icons';

import YourCareBoxView from './box/YourCareBoxView';
import MedicalHistoryBoxView from './box/MedicalHistoryBoxView';
import CareRoutineBoxView from './box/CareRoutineBoxView';
import CaregiverBoxView from './box/CaregiverBoxView';
import CareScheduleBoxView from './box/CareScheduleBoxView';
import FamilyContactsBoxView from './box/FamilyContactsBoxView';

const FormView = (props) => {
  const {data, setEditMode} = props;
  const formData = data;

  return (
    <Box sx={{position: 'relative', height: '100%', minHeight: 400}}>
      <Stack spacing={2}>
        <YourCareBoxView
          data={formData}
        />
        <MedicalHistoryBoxView
          data={formData}
        />
        <CareRoutineBoxView
          data={formData}
        />
        <CaregiverBoxView
          data={formData}
        />
        <CareScheduleBoxView
          data={formData}
        />
        <FamilyContactsBoxView
          data={formData}
        />
      </Stack>
      <IconButton
        id="form-edit-btn"
        onClick={() => setEditMode(true)}
        style={{
          position: 'sticky',
          bottom: 16,
          marginLeft: 'auto',
          zIndex: 1000,
          background: '#3060d9',
          color: '#fff',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          width: 48,
          height: 48,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 28,
          transition: 'background 0.2s',
        }}
      >
        <Edit style={{fontSize: 24, color: '#fff'}} />
      </IconButton>
    </Box>
  );
};

FormView.propTypes = {
  data: PropTypes.object.isRequired,
  setEditMode: PropTypes.func.isRequired,
};

export default FormView;
